import React from 'react'

import {
    FPConfirmationTitleDiv,
    FPConfirmationTitle,
    FPConfirmationPhraseDiv,
    FPConfirmationPhrase,
    FPConfirmationExitPhrase
} from '../../Styles/Components/ForgotPasswordConfirmStyles'

import { useSelector } from 'react-redux'

function ForgotPasswordConfirm(props){
    const email = useSelector(state => state.forgotPassword.email)

    return (
        <>
            <FPConfirmationTitleDiv>
                <FPConfirmationTitle>Email Sent</FPConfirmationTitle>
            </FPConfirmationTitleDiv>
            <FPConfirmationPhraseDiv>
                <FPConfirmationPhrase>An email has been sent to {email} with details to reset your account's password.</FPConfirmationPhrase>
            </FPConfirmationPhraseDiv>
            <FPConfirmationPhraseDiv>
                <FPConfirmationExitPhrase>Please exit this tab and follow the steps in your email.</FPConfirmationExitPhrase>
            </FPConfirmationPhraseDiv>
        </>
    )
}

export default ForgotPasswordConfirm